(() => {
  'use strict';

  const GLOBAL_KEY = 'FlyAndBagPayPalMessages';
  const SDK_ID = 'flyandbag-paypal-sdk';
  const SDK_URL = 'https://www.paypal.com/sdk/js?client-id=BAAdIrXqaJNkPvXvkzUP11bXb-lElIoaUQ_s5RUVSzqKVJ7kgAb0fpEIYJWvle1WEJgF57HCzrMRJuMWGw&components=messages&currency=EUR&locale=fr_FR';

  if (window[GLOBAL_KEY]?.refresh) {
    window[GLOBAL_KEY].refresh();
    return;
  }

  const priceMaps = new WeakMap();
  let sdkPromise;

  function getWrappers(root = document) {
    const wrappers = Array.from(root.querySelectorAll?.('[data-flyandbag-paypal-wrapper]') || []);
    if (root instanceof Element && root.matches('[data-flyandbag-paypal-wrapper]')) wrappers.unshift(root);
    return [...new Set(wrappers)];
  }

  function getPriceMap(wrapper) {
    if (priceMaps.has(wrapper)) return priceMaps.get(wrapper);
    const data = wrapper.querySelector('[data-flyandbag-paypal-prices]');
    let prices = {};
    try { prices = JSON.parse(data?.textContent || '{}'); } catch (error) { prices = {}; }
    priceMaps.set(wrapper, prices);
    return prices;
  }

  function getProductScope(wrapper) {
    return wrapper.closest('product-info, product-form, .product-information, [data-product-id], .shopify-section') || document;
  }

  function getSelectedVariantId(wrapper) {
    const scope = getProductScope(wrapper);
    const input = scope.querySelector('form[action*="/cart/add"] input[name="id"]') || scope.querySelector('input[name="id"]');
    return input?.value ? String(input.value) : '';
  }

  function getAmount(wrapper) {
    const prices = getPriceMap(wrapper);
    const selectedVariantId = getSelectedVariantId(wrapper);
    const selectedPrice = selectedVariantId ? prices[selectedVariantId] : undefined;
    const amount = Number(selectedPrice ?? wrapper.dataset.initialAmount);
    return Number.isFinite(amount) && amount > 0 ? amount : null;
  }

  function loadSdk() {
    if (window.paypal?.Messages) return Promise.resolve(window.paypal);
    if (sdkPromise) return sdkPromise;

    sdkPromise = new Promise((resolve, reject) => {
      const existing = document.getElementById(SDK_ID);
      if (existing) {
        if (window.paypal?.Messages) return resolve(window.paypal);
        existing.addEventListener('load', () => resolve(window.paypal), { once: true });
        existing.addEventListener('error', reject, { once: true });
        return;
      }

      const script = document.createElement('script');
      script.id = SDK_ID;
      script.src = SDK_URL;
      script.async = true;
      script.dataset.partnerAttributionId = 'FlyAndBag_Cart';
      script.addEventListener('load', () => resolve(window.paypal), { once: true });
      script.addEventListener('error', reject, { once: true });
      document.head.appendChild(script);
    });

    return sdkPromise;
  }

  async function renderWrapper(wrapper) {
    if (!(wrapper instanceof HTMLElement)) return;
    const target = wrapper.querySelector('[data-flyandbag-paypal-message]');
    const amount = getAmount(wrapper);

    if (!target || !amount) {
      wrapper.removeAttribute('data-rendered');
      return;
    }

    const amountKey = amount.toFixed(2);
    if (wrapper.dataset.paypalAmount === amountKey && target.childElementCount > 0) return;

    wrapper.dataset.paypalAmount = amountKey;
    wrapper.removeAttribute('data-rendered');
    target.replaceChildren();

    try {
      const paypal = await loadSdk();
      if (!paypal?.Messages || !document.contains(wrapper)) return;

      await paypal.Messages({
        amount,
        pageType: 'product-details',
        style: {
          layout: 'text',
          logo: { type: 'inline' },
          text: { color: 'black' }
        }
      }).render(target);

      if (document.contains(wrapper)) wrapper.dataset.rendered = 'true';
    } catch (error) {
      wrapper.removeAttribute('data-rendered');
    }
  }

  function refresh(root = document) {
    getWrappers(root).forEach((wrapper) => renderWrapper(wrapper));
  }

  function refreshFromEvent(event) {
    const eventTarget = event?.target instanceof Element ? event.target : null;
    const scope = eventTarget?.closest('product-info, product-form, .product-information, [data-product-id], .shopify-section') || document;
    window.setTimeout(() => refresh(scope), 0);
    window.setTimeout(() => refresh(scope), 120);
  }

  document.addEventListener('change', refreshFromEvent, true);
  document.addEventListener('variant:change', refreshFromEvent);
  document.addEventListener('variant:update', refreshFromEvent);
  document.addEventListener('product:variant-change', refreshFromEvent);
  document.addEventListener('shopify:section:load', (event) => refresh(event.target));

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (!(node instanceof Element)) continue;
        if (node.matches('[data-flyandbag-paypal-wrapper]') || node.querySelector('[data-flyandbag-paypal-wrapper]')) refresh(node);
      }
    }
  });

  function start() {
    refresh();
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  window[GLOBAL_KEY] = { refresh };
})();
